import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { install } from 'redux-loop';
import middleware from './middleware';
import createReducer from './reducers';

export default (initialState = {}) => {
  const composedEnhancers = __DEV__ ? composeWithDevTools : compose;

  if (window.Cypress) {
    if (window.cypressInitialSegmentState) {
      initialState.segmentState = window.cypressInitialSegmentState;
    }

    if (window.cypressQueryParams) {
      initialState.queryParams = window.cypressQueryParams;
    }

    if (window.cypressIdentityVerified) {
      initialState.identityVerified = window.cypressIdentityVerified;
    }
  }

  const reducers = createReducer(initialState);
  const enhancer = composedEnhancers(applyMiddleware(...middleware), install());
  const store = createStore(reducers, {}, enhancer);

  if (__DEV__ && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(reducers));
  }

  return store;
};
